// extracted by mini-css-extract-plugin
export default {"post":"post_post__IDoll"};